export default __webpack_public_path__ + "static/media/infr.603b6af3.svg";